import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import { UserContext } from '../common/UserContext';
import config from "../../envconfig";

function ShipmentReturnView() {

    const [tableRecords, setTableRecords] = useState([]);
    const [shipmentDetails, setShipmentDetails] = useState(null);

    const [selectedenumStatus, setSelectedenumStatus] = useState('');
    const [selectedreturnreason, setSelectedreturnreason] = useState('');
    const [enumtype, setEnumtype] = useState('');
    const [returnreason, setReturnReason] = useState('');
     const { shipmentCode } = useParams();
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode } = useContext(UserContext);

    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('shipmentCode', shipmentCode);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);

        sessionStorage.setItem('selectedScpId', selectedScpId);

    }, [UM_GroupId, UM_CompanyGrpID, shipmentCode, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

    const logAction = async (action, isError = false) => {
        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ module: "Shipment Outward Creation:", action, userCode: UM_UserCode, isError }),
            });
            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                // Fetch details from /shipmentreturnupdate/:shipmentCode
                const detailsResponse = await fetch(`${config.API_URL}/shipmentreturnview/${shipmentCode}`);
                if (!detailsResponse.ok) {
                    throw new Error('Failed to fetch shipment details');
                }
                const detailsData = await detailsResponse.json();
                setShipmentDetails(detailsData.shipmentDetails);
                setSelectedenumStatus(detailsData.shipmentDetails.SHPR_Status);
                setSelectedreturnreason(detailsData.shipmentDetails.SHPR_ReturnReason);
                logAction('Shipment details fetched successfully', false);

                // Ensure shipmentDetails exists and access SHPR_SCPCode
                if (detailsData.shipmentDetails) {
                    // Fetch table data from /shipmentreturn/tableData/:shipmentCode
                    const tableDataResponse = await fetch(`${config.API_URL}/shipmentreturn/tableData/${shipmentCode}`);
                    if (!tableDataResponse.ok) {
                        throw new Error('Failed to fetch table data');
                    }
                    const tableData = await tableDataResponse.json();

                    // Set default table records
                    const initialTableRecords = tableData.tableData.map(record => ({
                        SCPCode: detailsData.shipmentDetails.SHPR_SCPCode, // Ensure detailsData.shipmentDetails is used here
                        SCPName: detailsData.shipmentDetails.SCPM_Name, // You need to set SCPName appropriately based on your data
                        ShipmentCode: record.SHPDR_ShipmentCode,
                        ProductName: record.SHPDR_ProductName,
                        ProductCode: record.SHPDR_ProductCode,
                        ReceivedQuantity: record.SHPDR_ReceivedQty,
                        ReturnQuantity: record.SHPDR_ShipQty,
                    }));
                    setTableRecords(initialTableRecords);
                    logAction('Table data fetched and set successfully', false);
                } else {
                    throw new Error('shipmentDetails not found in response');
                }
            } catch (error) {
                console.error('Error fetching initial data:', error);
                logAction(`Error fetching initial data: ${error.message}`, true);
                // Handle error state if needed
            }
        };

        const fetchEnumType = async () => {
            try {
                const response = await fetch(`${config.API_URL}/api/enumtype/${selectedenumStatus}`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                const { enumtype } = data;
                setEnumtype(enumtype);
                logAction('Enum type fetched successfully', false);
            } catch (error) {
                console.error('Error fetching enum type:', error);
                logAction(`Error fetching enum type: ${error.message}`, true);
                // Handle error state if needed
            }
        };

        const fetchReturnReason = async () => {
            try {
                const response = await fetch(`${config.API_URL}/returnreason/${selectedreturnreason}`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                const { returnReason } = data;
                setReturnReason(returnReason);
                logAction('Return reason fetched successfully', false);
            } catch (error) {
                console.error('Error fetching return reason:', error);
                logAction(`Error fetching return reason: ${error.message}`, true);
                // Handle error state if needed
            }
        };

        // Execute all fetch functions when dependencies change
        fetchReturnReason();
        fetchEnumType();
        fetchInitialData();
    }, [shipmentCode, selectedenumStatus, selectedreturnreason]);

    return (
        <>
            <div className="main_container">
                <h1 className="formHeading">Shipment Return</h1>
                <form  autoComplete="off">
                    <div className="row mb-3">
                        <div className="col-sm-6">
                            <label htmlFor="shipmentType">Shipment Type</label>
                            <input
                                type="text"
                                className="form-input"
                                value={shipmentDetails ? shipmentDetails.SHPR_ShipmentType : ''}
                                disabled
                            />
                        </div>
                        <div className="col-sm-6">
                            <label htmlFor="returnReason">Return Reason </label>
                            <input
                                type="text"
                                className="form-input"
                                value={shipmentDetails ? shipmentDetails.ReturnReasonDescription : ''}
                                disabled
                            />
                        </div>
                        <div className="col-sm-6">
                            <label htmlFor="returnComment">Return Comment</label>
                            <input
                                type="text"
                                className="form-input"
                                value={shipmentDetails ? shipmentDetails.SHPR_ReturnRemarks : ''}
                                disabled
                            />
                        </div>
                        <div className="col-sm-6">
                            <label htmlFor="shipmentDate">Shipment Date</label>
                            <input
                                type="text"
                                className="form-input"
                                value={shipmentDetails ? shipmentDetails.SHPR_ShipmentDate : ''}
                                disabled
                            />
                        </div>
                        {/* </div> */}
                        {/* <div className="row mb-3"> */}
                        <div className="col-sm-6">
                            <label className="form-label">Logistic Party Name</label>
                            <input
                                type="text"
                                className="form-input"
                                value={shipmentDetails ? shipmentDetails.LGCM_Name : ''}
                                disabled
                            />
                        </div>
                        <div className="col-sm-6">
                            <label className="form-label">Vehicle Number</label>
                            <input
                                type="text"
                                className="form-input"
                                value={shipmentDetails ? shipmentDetails.LGCVM_VehicleNumber : 'N/A'}
                                disabled
                            />
                        </div>
                        <div className="col-sm-6">
                            <label className="form-label">Shipment Status</label>
                            <input
                                type="text"
                                className="form-input"
                                StatusDescription
                                value={shipmentDetails ? shipmentDetails.StatusDescription : ''}
                                disabled
                            />
                        </div>
                        <div className="col-sm-6">
                            <label htmlFor="shipment">SCP Name</label>
                            <input
                                type="text"
                                className="form-input"
                                value={shipmentDetails ? shipmentDetails.SCPM_Name : ''}
                                disabled
                            />
                        </div>
                    </div>

                </form>
                {/* Table to display records */}
                {tableRecords.length > 0 && (
                    <div className="table_container mt-3">
                        <table className="tableClass">
                            <thead>
                                <tr>
                                    <th>SCP Name</th>
                                    <th>Shipment Code</th>
                                    <th>Product Name</th>
                                    <th>Product Code</th>
                                    <th>Received Quantity</th>
                                    <th>Return Quantity</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableRecords.map((record, index) => (
                                    <tr key={index}>
                                        <td>{record.SCPName}</td>
                                        <td>{record.ShipmentCode}</td>
                                        <td>{record.ProductName}</td>
                                        <td>{record.ProductCode}</td>
                                        <td>{record.ReceivedQuantity}</td>
                                        <td>{record.ReturnQuantity}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            <Link to={`/shipmentreturnlist`} className="back_btn" type="button">
                BACK
            </Link>
        </>
    );
}

export default ShipmentReturnView;
